import { render, staticRenderFns } from "./CellRendererPartner.vue?vue&type=template&id=4b968112&"
import script from "./CellRendererPartner.vue?vue&type=script&lang=js&"
export * from "./CellRendererPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports